import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Leads from "@/pages/Leads";
import LeadDetail from "@/pages/LeadDetail";
import Pipeline from "@/pages/Pipeline";
import Meetings from "@/pages/Meetings";
import Tasks from "@/pages/Tasks";
import Activities from "@/pages/Activities";
import EOD from "@/pages/EOD";
import Reports from "@/pages/Reports";
import Team from "@/pages/Team";
import SettingsPage from "@/pages/Settings";
import Profile from "@/pages/Profile";

const Protected = ({ children, admin }) => {
  const { user, meta, isAdmin } = useAuth();
  if (user === null || (user && !meta)) {
    return <div className="flex h-screen items-center justify-center text-sm text-muted-foreground" data-testid="app-loading">Loading CRM…</div>;
  }
  if (!user) return <Navigate to="/login" replace />;
  if (admin && !isAdmin) return <Navigate to="/dashboard" replace />;
  return children;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route element={<Protected><Layout /></Protected>}>
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/leads" element={<Leads />} />
            <Route path="/leads/:id" element={<LeadDetail />} />
            <Route path="/pipeline" element={<Pipeline />} />
            <Route path="/meetings" element={<Meetings />} />
            <Route path="/tasks" element={<Tasks />} />
            <Route path="/activities" element={<Activities />} />
            <Route path="/eod" element={<EOD />} />
            <Route path="/reports" element={<Reports />} />
            <Route path="/team" element={<Protected admin><Team /></Protected>} />
            <Route path="/settings" element={<SettingsPage />} />
            <Route path="/profile" element={<Profile />} />
          </Route>
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster richColors position="top-right" />
    </AuthProvider>
  );
}

export default App;
